import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { disciplinaLst } from 'src/app/models/disciplinaLst';
import { CreateEditDisciplinaComponent } from '../create-edit-disciplina/create-edit-disciplina.component';

@Component({
  selector: 'app-index-disciplina',
  templateUrl: './index-disciplina.component.html',
  styleUrls: ['./index-disciplina.component.scss']
})
export class IndexDisciplinaComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public disciplinaSvc: DisciplinaService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: disciplinaLst[] = [];
    this.displayedColumns = ['nombre', 'estado', 'botones'];

    this.dataSource = new MatTableDataSource<disciplinaLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getDisciplinas(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDisciplinas(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.disciplinaSvc
      .getDisciplinas(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<disciplinaLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
console.log('resultado: ', result)
        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getDisciplinas(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getDisciplinas(0, 10);
  }

  openDialogCreate(): void {
     let dialogRef = this.dialog.open(CreateEditDisciplinaComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result=='false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getDisciplinas(this.pageIndex, this.pageSize);
      }
    }); 
  }

  edit(obj: any) {
    console.log(obj);

   let dialogRef = this.dialog.open(CreateEditDisciplinaComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result=='false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getDisciplinas(this.pageIndex, this.pageSize);
      }
    }); 
  }

  delete(obj: any) {
    console.log(obj);
    this.alertify.confirm('Confirma que quiere eliminar la disciplina?', () => {
      this.disciplinaSvc.deleteDisciplina(obj.id).subscribe((res) => {
        if (res) {
          this.getDisciplinas(this.pageIndex, this.pageSize);
          this.alertify.success('Disciplina eliminada.');
        } else {
          this.alertify.error('La disciplina no se ha podido eliminar.');
        }
      });
    });
  }


}
